export const logoIcon = require('./logo.png');
export const chevronBottomIcon = require('./header-chevron-bottom.png');
export const callIdIcon = require('./call-id.png');
export const dateIcon = require('./date.png');
export const pinIcon = require('./pin.png');
export const phoneIcon = require('./phone.png');
export const plusIcon = require('./plus.svg').default;
export const sendMessageIcon = require('./send-message.png');
export const durationIcon = require('./duration.png');
export const noConnectionCameraIcon = require('./no-connection-camere.png');
export const clearScreenIcon = require('./clear-screen.png');
export const cameraIcon = require('./camera.png');
export const flashIcon = require('./flash.png');
export const micIcon = require('./mic.png');
export const muteIcon = require('./mute.png');
export const whitePhoneIcon = require('./white-phone.png');
export const uploadIcon = require('./upload.png');
export const downloadIcon = require('./download.png');
export const checkIcon = require('./check.png');
export const informativeIcon = require('./informative-icon.png');
export const successIcon = require('./success-icon.png');
export const warningIcon = require('./warning-icon.png');
export const errorIcon = require('./error-icon.png');
export const warningBlackIcon = require('./warning.png');
export const saveIcon = require('./save.png');
export const thanksIcon = require('./thanks.png');
export const selfixLogoIcon = require('./selfix-logo.png');
export const reviewIcon = require('./review.png');
export const submitIcon = require('./submit.png');
export const secureIcon = require('./secure.png');
export const customerCallBgIcon = require('./customer-call-bg.png');
export const chatIcon = require('./chat.png')
export const endCallIcon = require('./end-call.png')
export const closeIcon = require('./close.png')
export const imageIcon = require('./image.png')
export const loginBgIcon = require('./login-bg.png')
export const selfixBigLogoIcon = require('./selfix-big-logo.png')
export const emailIcon = require('./email.png')
export const passwordIcon = require('./password.png')
export const rightArrowIcon = require('./right-arrow.png')
export const videoCameraIcon = require('./video-camera.png')
export const logOutIcon = require('./log-out.png')
export const selfixSmallLogoIcon = require('./selfix-small-logo.png')
export const flashOffIcon = require('./flash-off.png')
export const micOffIcon = require('./mic-off.png')
export const volumeUpIcon = require('./volume-up.png')
export const undoIcon = require('./undo.png')
export const redoIcon = require('./redo.png')
export const customerLoginBgIcon = require('./customer-login-bg.png')
export const vestelLogoIcon = require('./vestel-logo.png')
export const checkDisabledIcon = require('./check-disabled.png')
export const whiteVideoCameraIcon = require('./white-video-camera.png')
export const whiteCheckIcon = require('./white-check-icon.png')
export const issueSolvedIcon = require('./issue-solved.png')
export const sparePartIcon = require('./spare-part.png')
export const canNotConnectIcon = require('./can-not-connect.png')
export const questionIcon = require('./question.png')
export const contentTypeDocIcon = require('./content-type-doc.png')
export const contentTypeImageIcon = require('./image.png')
export const recordingIcon = require('./recording.png')
export const notRecordingIcon = require('./not-recording.png')
export const selfixLoaderIcon = require('./selffix_loader.gif')
export const sideBarSessionLogsIcon = require('./side-bar-session-logs.png')
export const sideBarDashboardIcon = require('./side-bar-dashboard.png')
export const backIcon = require('./back.png')
export const cancelIcon = require('./cancel.png')
export const recordIcon = require('./record.png')
export const profileIcon = require('./profile.png')
export const downArrowIcon = require('./down-arrow.png')
export const chatBubbleIcon = require('./chat-bubble.png')
export const chevronLeftIcon = require('./chevron-left.png')
export const chevronRightIcon = require('./chevron-right.png')
export const sortCallsIcon = require('./sort-calls.png')
export const bigPhoneIcon = require('./big-phone.png')
export const greyRightArrowIcon = require('./grey-right-arrow.png')
export const trashIcon = require('./trash-icon.png')
export const searchIcon = require('./search-icon.png')